module.exports = __webpack_public_path__ + "img/picture.3c183fb7.jpg";